import React from 'react';
import ContainerBlock from '@components/ContainerBlock';
import Text from '@components/Text';
import Link from '@components/Link';
import { useTheme, ITheme } from 'src/theme';

export interface Information {
	label: string;
	value: string;
	type: 'email' | 'phone' | 'other'
}
export interface ContactBoxProps {
	theme? :ITheme;
	items: Information[];
	noDecorator: boolean;
}

function ContactBox({ items, noDecorator }: ContactBoxProps) {
	const theme = useTheme();
	const boxShadow = noDecorator ? 'none' : '0 2px 2px 0 rgba(204, 204, 204, 0.5)';
	const background = noDecorator ? 'unset' : theme.colors.grey[200];
	const padding = noDecorator ? 0 : 20;
	const paddingTablet = noDecorator ? 0 : "25px 30px";
	const borderTop = noDecorator ? 'none' : `3px solid ${theme.colors.primary}`;
	return (
		<ContainerBlock background={background} boxShadow={boxShadow} paddingTablet={paddingTablet} padding={padding} borderTop={borderTop}>
			{!noDecorator && <Text  margin={'0 0 20px'} fontSize={theme.fontSize.smallTitle} color={theme.colors.grey[400]} fontWeight={600}>Need help?</Text>}
			{items.map((item: Information, index: number) => {	
				return (
					<ContainerBlock margin={index === items.length - 1 ? '0' : '0 0 20px'} key={`${index}`}>
						<Text 
							fontWeight={noDecorator ? 600 : 'bold'}
							color={(noDecorator && item.type !== 'other') ? theme.colors.grey[300] : theme.colors.grey[500]}
							fontSize={(noDecorator && item.type !== 'other') ? theme.fontSize.label : theme.fontSize.text}
						>{item.label}</Text>
						{
							item.type !== 'other' ? 
							<Link 
								underline={!noDecorator}
								fontSize={noDecorator ?  theme.fontSize.subtitle : theme.fontSize.text}
								fontSizeTablet={noDecorator ? theme.fontSizeTablet.smallTitle : theme.fontSize.text}
								fontWeightTablet={noDecorator ? 600 : 'bold'}
								fontWeight={'bold'}
								url={`${item.type === 'email' ? 'mailto' : 'tel'}:${item.value.replace(' ', '')}`} 
								text={item.value} 
							/> : 
							<Text>{item.value}</Text>
						}
					</ContainerBlock>
				)
			})}
		</ContainerBlock>
	);
};



ContactBox.defaultProps = {
	items: [],
	noDecorator: false
}

export default ContactBox;
